module.exports = __webpack_public_path__ + "gfx/SD-29.png";